// import React from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "./providers/AuthProvider";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";

// Pages
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { AuthCallback } from "./pages/AuthCallback";
import { Chat } from "./pages/Chat";
import { Projects } from "./pages/Projects";
import { Integrations } from "./pages/Integrations";
import { IntegrationSuccess } from "./pages/IntegrationSuccess";
import { Settings } from "./pages/Settings";
import { DevTools } from "./pages/DevTools";
import { NotFound } from "./pages/NotFound";

// Layout
import { AppLayout } from "./components/layout/AppLayout";

function App() {
  return (
    <AuthProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <div className="min-h-screen bg-gray-50">
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/auth/callback" element={<AuthCallback />} />

            {/* Protected routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/chat" replace />} />
              <Route path="chat" element={<Chat />} />
              <Route path="projects" element={<Projects />} />
              <Route path="integrations" element={<Integrations />} />
              <Route
                path="integrations/:provider/success"
                element={<IntegrationSuccess />}
              />
              <Route path="settings" element={<Settings />} />
              <Route path="devtools" element={<DevTools />} />
            </Route>

            {/* 404 Not Found - catch all route */}
            <Route path="*" element={<NotFound />} />
          </Routes>

          {/* Global toast notifications */}
          <Toaster />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
// Test trigger
